import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Oggi (b_chwjy424g8, advertiser 4748191580351722375).
// Real numbers from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS
// (complete months Nov 2025 – Jul 2026; 9-month tenure). NEW_ONLY — a single
// new-customers campaign, still RUNNING. Budget-capped archetype: spend lands
// on the monthly budget almost every month while the budget was raised from
// ~$85 to $525, a 6.6x first-year ROAS, and an active increase recommendation.
// Monthly series + partial Aug 2026 live in realBrandData.ts.
export const advOggi: FaireAdvertiserProfileEntity = {
  token: "adv_oggi",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Oggi",
  brandToken: "b_chwjy424g8",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 9,
  budget: {
    totalBudgetDollars: 525,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-09-01",
    nextBillsAtDate: "2026-09-04",
  },
  overview: {
    numCustomersAcquired: 38,
    numReorderConversions: 0,
    numTotalConversions: 38,
    totalAdsSalesDollars: 18938,
    newCustomerAdsSalesDollars: 18938,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 2864,
    newCustomerAdsSpendDollars: 2864,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 6.61,
    reorderRoas: 0,
    combinedFirstYearRoas: 6.61,
    // MANAGER_METRICS_BRAND_ORDERS: 54 ad-attributed orders from the 38
    // acquired customers; no reorder campaign exists.
    numNewCustomerAdsOrders: 54,
    numReorderAdsOrders: 0,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 630,
      maxRecommendedBudgetDollars: 1260,
      isEligibleForIncreaseRec: true,
    },
  },
  campaignTokens: ["camp_og_new"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
